const formatErrorMessage = response => {
  if (response && response.errors) {
    return JSON.stringify(response.errors);
  }

  return 'null';
}

export default class HttpError extends Error {
  constructor(rawResponse, jsonResponse) {
    super(formatErrorMessage(jsonResponse));

    this.traceId = rawResponse.headers.get('x-trace-id');
    this.response = rawResponse;
    this.status = rawResponse.status;

    if (jsonResponse) {
      this.errors = jsonResponse.errors;
    }
  }

  toString() {
    const baseError = super.toString();
    const errMsg = `HttpError status:${this.status} error:${baseError} url:${this.response.url} traceId:${this.traceId}`;

    return errMsg;
  }

  raw() { return this.response; }
}

export function asyncStackCapture(outerErrorMessage, fn) {
  return function (...args) {
    const outerErr = new Error(outerErrorMessage);
    async function innerFn() {
      try {
        const res = await fn(...args);
        return res;
      } catch (err) {
        amendErrorStackAndRethrow(outerErr, err);
      }
    }

    return innerFn();
  };
}

export function amendErrorStackAndRethrow(outerError, innerError) {
  innerError.stack = `${outerError.stack}\n${innerError.stack}`;

  throw innerError;
}